import React from 'react';
import {Link} from 'react-router-dom';

interface DocumentProps {
	title: string;
	url: string;
}

export function Document({title, url}: DocumentProps): React.ReactElement {
	return (
		<Link
			className="flex items-center justify-between bg-white pl-4 py-2 pr-2 cursor-pointer rounded-r-full"
			to={url}
			target="_blank"
			rel="noopener noreferrer"
		>
			<div className="text-base font-medium">{title}</div>
			<div className="w-16 h-16 rounded-full bg-[#F3F3F3] flex items-center justify-center">
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19 2V9H26L19 2Z" fill="black" />
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M17.1111 2V11H26V30H6V2H17.1111ZM9 16H23V18H9V16ZM23 21H9V23H23V21Z"
						fill="black"
					/>
				</svg>
			</div>
		</Link>
	);
}
